//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminObligationController_deleteOneById,
  Response$AdminObligationController_deleteOneById$Status$200,
  ResponseContentType$AdminObligationController_deleteOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminObligationController_deleteOneById = () =>
  useApiClientMutation<
    Params$AdminObligationController_deleteOneById,
    Response$AdminObligationController_deleteOneById$Status$200[ResponseContentType$AdminObligationController_deleteOneById]
  >({ method: 'AdminObligationController_deleteOneById' });
